<template>
  <div class="login-wrapper">
    <div :class="wider ? 'login-wrapper__innerwider':'login-wrapper__inner'">
      <slot />
    </div>
  </div>
</template>

<script>
    export default {
        name: 'LoginWrapper',
        props: {
            wider: {
                type: Boolean,
                default: false
            },
        }
    }
</script>